module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModle) ? _c('div', {
    staticClass: "slideVerify"
  }, [_c('div', {
    staticClass: "popup-modal",
    on: {
      "click": _vm.outModel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "20px",
      "top": "20px"
    },
    on: {
      "click": _vm.outModel
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "src": require("../../../assets/img/login/close.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "12px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-content-title",
    staticStyle: {
      "color": "#666666"
    }
  }, [_vm._v("安全验证")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#333333",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("拖动下方滑动完成拼图")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "12px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sliderImg"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.url + '/' + _vm.imgObj.background,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "sliderImgBtn",
    style: ({
      'top': ((1 - _vm.imgObj.height) * 100) + '%',
      'left': _vm.progressValue + 'px'
    }),
    attrs: {
      "src": _vm.url + '/' + _vm.imgObj.bloke,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "12px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "movable-area"
  }, [_c('div', {
    staticClass: "movable-view",
    style: ({
      'left': _vm.progressValue + 'px'
    }),
    on: {
      "mousedown": _vm.sliderDown,
      "touchstart": _vm.touchStartEvent,
      "touchmove": _vm.handleMoveEvent,
      "touchend": _vm.handleMoveEndEvent
    }
  }, [(_vm.loading) ? _c('img', {
    attrs: {
      "src": require("../../../assets/img/login/timg-loading.png"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/img/login/slider-right.png"),
      "alt": ""
    }
  })])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adaf5fc2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/components/slideVerify.vue
// module id = 561
// module chunks = 0